import { Select, Typography } from "antd";
import { BankOutlined } from "@ant-design/icons";
import { useBoundStore } from "store";
import { useNavigate } from "react-router-dom";
import "./OrganizationSelector.scss";

interface OrganizationSelectorProps {
  collapsed: boolean;
}

export const OrganizationSelector = ({ collapsed }: OrganizationSelectorProps) => {
  const { currentOrganization, organizations, tenant, setCurrentOrganization } =
    useBoundStore();
  const navigate = useNavigate();

  // Don't show anything if no organization
  if (!currentOrganization) {
    return null;
  }

  // Show static display if only one organization
  if (!organizations || organizations.length <= 1) {
    if (collapsed) {
      return (
        <div className="organization-selector organization-selector--collapsed">
          <BankOutlined className="organization-selector__icon" />
        </div>
      );
    }

    return (
      <div className="organization-selector">
        <Typography.Text
          type="secondary"
          className="organization-selector__label"
        >
          Organization
        </Typography.Text>
        <Typography.Text strong className="organization-selector__name">
          {currentOrganization?.name}
        </Typography.Text>
      </div>
    );
  }

  const handleOrgChange = (orgId: string) => {
    const newOrg = organizations.find((o) => o.id === orgId);
    if (newOrg) {
      setCurrentOrganization(newOrg);
      navigate(`/${tenant?.id}/organizations/${orgId}/dashboard`);
    }
  };

  if (collapsed) {
    return (
      <div className="organization-selector organization-selector--collapsed">
        <BankOutlined className="organization-selector__icon" />
      </div>
    );
  }

  return (
    <div className="organization-selector">
      <Typography.Text
        type="secondary"
        className="organization-selector__label"
      >
        Organization
      </Typography.Text>
      <Select
        value={currentOrganization?.id}
        onChange={handleOrgChange}
        className="organization-selector__select"
        options={organizations.map((org) => ({
          value: org.id,
          label: org.name,
        }))}
      />
    </div>
  );
};
